import { Wind } from "lucide-react";
import { BRAND } from "@/data/product";

export default function Footer() {
    return (
        <footer data-testid="footer" className="border-t border-white/10 py-12">
            <div className="max-w-7xl mx-auto px-5 md:px-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
                <div className="flex items-center gap-2">
                    <Wind className="w-5 h-5 text-cyan-300" />
                    <span className="font-display tracking-[0.25em] text-sm uppercase">{BRAND}</span>
                </div>
                <nav className="flex flex-wrap gap-x-8 gap-y-2 text-xs uppercase tracking-[0.18em] text-zinc-500">
                    <a href="#shop" className="hover:text-white transition-colors" data-testid="footer-link-shop">Shop</a>
                    <a href="#cooling" className="hover:text-white transition-colors" data-testid="footer-link-cooling">Cooling Tech</a>
                    <a href="#faq" className="hover:text-white transition-colors" data-testid="footer-link-faq">FAQ & Shipping</a>
                </nav>
                <p className="text-xs text-zinc-600">© 2026 {BRAND}. Stay cool anywhere.</p>
            </div>
        </footer>
    );
}
